import { Link } from 'react-router-dom'

export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-3xl px-4 py-10">
        <div className="text-2xl font-semibold text-slate-900">Política de Privacidade (LGPD)</div>
        <div className="mt-2 text-sm text-slate-500">
          Versão 1.0 • Uso corporativo • RH e obrigações legais
        </div>

        <div className="mt-8 space-y-5 rounded-2xl border border-slate-200 bg-white p-6 text-sm text-slate-700">
          <p>
            Este sistema trata dados pessoais para fins de gestão de RH, cumprimento de obrigações
            legais e execução de cálculos trabalhistas. O acesso é controlado por perfil e por empresa
            (multi-tenant), com logs de acesso para auditoria.
          </p>
          <p>
            Dados sensíveis (ex.: CPF e remuneração) são protegidos por controles de acesso e
            criptografia em repouso no backend. O titular pode solicitar exportação e, quando
            permitido, anonimização.
          </p>
          <p>
            O responsável (controlador) é a empresa contratante do serviço; o sistema atua como
            operador. Para solicitações, utilize o canal oficial do seu administrador.
          </p>
        </div>

        <div className="mt-6 text-sm">
          <Link className="text-slate-900 underline" to="/login">
            Voltar
          </Link>
        </div>
      </div>
    </div>
  )
}

